import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import * as _ from 'lodash';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { EmailDetailService } from '../services/email-detail.service';
import { UserService } from '../services/user.service';
import { AuthService } from '../services/auth.service';
import { SourceService } from '../services/source.service';
import { SessionService } from '../services/session2.service';
import { CacheService } from '../global/ng2-cache/services/cache.service';
import { ErrorService, Error } from '../services/error.service';
import { GlobalMessageService } from '../services/global-message.service';
import { ConfirmDialogComponent } from '../global/confirm-dialog/confirm-dialog.component';
import { AlertDialogComponent } from '../global/alert-dialog/alert-dialog.component';
import { DriftService } from '../services/drift.service';

import { DateRangePickerComponent } from '../global/date-range/date-range-picker.component';
import { Constants, EmailType } from '../global/constants';
import { SocketService } from '../services/socket.service';
import { AutomateJobService } from '../services/automate-job.service';
import { ApproveQService } from '../services/approve-q.service';
import { ClassifierService } from '../services/classifier.service';

interface IQuery {
  startDate: Date;
  endDate: Date;
  approve_status?: string[];
  bot_classification?: string[];
  recipient?: string[];
  source?: string[];
  type?: string[];
  sAdmin?: boolean;
  customerReviewQueueToggle?: boolean;
}

@Component({
  selector: 'app-inbox',
  templateUrl: './inbox.component.html',
  styleUrls: ['./inbox.component.scss']
})
export class InboxComponent implements OnInit {

  loadingPage: boolean = true;
  loadingCount: boolean = true;
  loadingDetail: boolean = true;
  session: any;
  emails: any[] = [];
  totalEmails: number = 0;
  selectedEmailId: string;
  perPage: number = 10;
  numPages: number = 0;
  exportData: string;
  qsEmailId: string;
  usersWithReviewNotifications: any[] = [];

  // source dropdown settings
  sources: any[] = [];
  selectedSources: any[] = [];
  sourceDDSettings: any = {
    text: 'All source(s)',
    unSelectAllText: 'Remove all',
    enableSearchFilter: true,
    badgeShowLimit: 0
  };

  // type dropdown settings
  types: any[] = [];
  selectedTypes: any[] = [];
  typeDDSettings: any = {
    text: 'All type(s)',
    unSelectAllText: 'Remove all',
    enableSearchFilter: false,
    badgeShowLimit: 0
  };

  // type dropdown bot statuses - sadmin view
  adminApproveStatuses: any[] = [
    {
      id: 'customer',
      itemName: 'Customer Needs Review'
    },
    {
      id: 'draft',
      itemName: 'Admin Needs Review'
    },
    {
      id: 'pending',
      itemName: 'Scheduled'
    },
    {
      id: 'complete',
      itemName: 'Completed'
    },
    {
      id: 'deleted',
      itemName: 'Cancelled'
    }
  ];

  // type dropdown bot statuses - customer view
  customerApproveStatuses: any[] = [
    {
      id: 'customer',
      itemName: 'Needs Review'
    },
    {
      id: 'pending',
      itemName: 'Scheduled'
    },
    {
      id: 'complete',
      itemName: 'Completed'
    },
    {
      id: 'deleted',
      itemName: 'Cancelled'
    }
  ];

  // type dropdown bot statuses - toggle off
  approveStatuses: any[] = [
    {
      id: 'draft',
      itemName: 'Needs Review'
    },
    {
      id: 'pending',
      itemName: 'Scheduled'
    },
    {
      id: 'complete',
      itemName: 'Completed'
    },
    {
      id: 'deleted',
      itemName: 'Cancelled'
    }
  ];

  selectedApproveStatuses: any[] = [];
  sAdmin: boolean = null;
  customerReviewQueueToggle: boolean = false;
  approveDDSettings: any = {
    text: 'Bot status(es)',
    unSelectAllText: 'Remove all',
    enableSearchFilter: false,
    badgeShowLimit: 0
  };

  botClassifications: any[] = []; // TODO: figure out a loading/error state for these
  selectedBotClassifications: string[] = [];
  botClassificationSettings: any = {
    text: 'Bot classification(s)',
    unSelectAllText: 'Remove all',
    enableSearchFilter: true,
    badgeShowLimit: 0
  };

  // Email modifications
  reportDialogRef: BsModalRef;
  typeDialogRef: BsModalRef;

  newType: string = '';

  report: any = {
    incorrectType: false,
    missingName: false,
    missingOther: false,
    invalidName: false,
    badAssociation: false,
    comments: ''
  };

  @ViewChild(DateRangePickerComponent) datePicker: DateRangePickerComponent;

  dateRangeOptions: any = {
    minDate: '01/01/2015',
    format: 'MM/DD/YYYY',
    autoApply: true
  };

  constructor(private sessionService: SessionService,
              private cacheService: CacheService,
              private errorService: ErrorService,
              private emailDetailService: EmailDetailService,
              private sourceService: SourceService,
              private modalService: BsModalService,
              private globalMessageService: GlobalMessageService,
              private driftService: DriftService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private cdRef: ChangeDetectorRef,
              private constants: Constants,
              private socketService: SocketService,
              private automateJobService: AutomateJobService,
              private approveQService: ApproveQService,
              private classifierService: ClassifierService,
              private userService: UserService,
              private authService: AuthService) { }

  ngOnInit() {
    // for deep linking, see if there's an email detail id in the query string
    this.qsEmailId = this.activatedRoute.snapshot.queryParams.ed;

    this.session = this.cacheService.get('session');
    if (this.session) {
      this.initView();

    } else {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.session = session;
          this.initView();
        }
      );
    }

    // soket-io event
    this.socketService
      .getEmailDetailUpdate()
      .subscribe((data) => {
        this.updateBotStatus(data.emailId, data.botStatus);
      });
  }

  typeAdd(item) {
    this.filterType();
  }

  typeRemove(item) {
    this.filterType();
  }

  typeAddAll(items) {
    this.selectedTypes = [];
    this.filterType();
  }

  typeRemoveAll(items) {
    this.filterType();
  }

  sourceAdd(item) {
    this.filterSource();
  }

  sourceRemove(item) {
    this.filterSource();
  }

  sourceAddAll(items) {
    this.filterSource();
  }

  sourceRemoveAll(items) {
    this.filterSource();
  }

  approveStatusAdd(items) {
    this.filterBotStatus();
  }

  approveStatusAddAll(items) {
    this.filterBotStatus();
  }

  approveStatusRemove(items) {
    this.filterBotStatus();
  }

  approveStatusRemoveAll(items) {
    this.filterBotStatus();
  }

  botClassificationAdd(items) {
    this.filterBotClassification();
  }

  botClassificationAddAll(items) {
    this.filterBotClassification();
  }

  botClassificationRemove(items) {
    this.filterBotClassification();
  }

  botClassificationRemoveAll(items) {
    this.filterBotClassification();
  }

  filterDate(range: any) {
    this.dateRangeOptions.startDate = range.start;
    this.dateRangeOptions.endDate = range.end;

    if (range.numDays) {
      this.session.inbox_filters.days = range.numDays;
      this.session.inbox_filters.range = null;
    }
    else {
      this.session.inbox_filters.days = 0;
      this.session.inbox_filters.range = {
        start: range.start,
        end: range.end
      }
    }

    this.session.inbox_filters.current_page = 0;
    this.session.inbox_filters.new_page = 1;
    this.session.inbox_filters.firstId = null;
    this.session.inbox_filters.lastId = null;
    this.resetData(false);
    this.saveSession();
  }

  filterType() {
    // 05-03-18 changing how selected sources are stored in session
    // the next line can be deleted after 3 months or so..say August of 2018?
    delete this.session.inbox_filters.type;

    this.session.inbox_filters.types = _.map(this.selectedTypes, (s: any) => s.id);
    this.session.inbox_filters.current_page = 0;
    this.session.inbox_filters.new_page = 1;
    this.session.inbox_filters.firstId = null;
    this.session.inbox_filters.lastId = null;
    this.resetData(false);
    this.saveSession();
  }

  filterSource() {
    // 12-31-17 changing how selected sources are stored in session
    // the next line can be deleted after 3 months or so..say March of 2018?
    delete this.session.inbox_filters.source;

    this.session.inbox_filters.sources = _.map(this.selectedSources, (s: any) => s.id);
    this.session.inbox_filters.current_page = 0;
    this.session.inbox_filters.new_page = 1;
    this.session.inbox_filters.firstId = null;
    this.session.inbox_filters.lastId = null;
    this.resetData(false);
    this.saveSession();
  }

  filterBotStatus() {
    this.session.inbox_filters.approve_status = _.map(this.selectedApproveStatuses, (s: any) => s.id);
    this.session.inbox_filters.current_page = 0;
    this.session.inbox_filters.new_page = 1;
    this.session.inbox_filters.firstId = null;
    this.session.inbox_filters.lastId = null;
    this.resetData(false);
    this.saveSession();
  }

  filterBotClassification() {
    this.session.inbox_filters.bot_classification = _.map(this.selectedBotClassifications, (s: any) => s.id);
    this.session.inbox_filters.current_page = 0;
    this.session.inbox_filters.new_page = 1;
    this.session.inbox_filters.firstId = null;
    this.session.inbox_filters.lastId = null;
    this.resetData(false);
    this.saveSession();
  }

  filterSearch() {
    this.session.inbox_filters.current_page = 0;
    this.session.inbox_filters.new_page = 1;
    this.session.inbox_filters.firstId = null;
    this.session.inbox_filters.lastId = null;
    this.resetData(false);
    this.saveSession();
  }

  changePage(page) {
    this.qsEmailId = null;
    this.changePageInternal(this.session.inbox_filters.new_page, page);
  }

  detail(edId: string) {
    this.qsEmailId = null;
    this.selectedEmailId = edId;
    // https://stackoverflow.com/questions/43698032/angular-how-to-update-queryparams-without-changing-route
    const queryParams: Params = Object.assign({}, this.activatedRoute.snapshot.queryParams);
    queryParams.ed = this.selectedEmailId;
    this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: queryParams });
  }

  rerun() {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: 'Please confirm you would like to re-run this email through automate skills',
        confirm: () => {
          me.emailDetailService.rerun(me.selectedEmailId).subscribe(
            () => {
              me.globalMessageService.message('Email was set for rerun');
              me.driftService.track('rerun-email');
            },
            (error) => {
              me.globalMessageService.error();
              me.errorService.log(error, 'inbox.component', 'rerun');
            }
          );
        }
      }
    }));
  }

  botReviewEmail(approveStatus: string) {

    const accountName = this.session ? this.session.account : null;
    const accountId = this.session ? this.session.account_id : null;
    const underReview = [];

    const options = {
      current_page: 0,
      query: {
        startDate: this.dateRangeOptions.startDate,
        endDate: this.dateRangeOptions.endDate,
        approve_status: [ approveStatus ]
      }
    };

    this.emailDetailService.getPaginated(options).subscribe(
      (result: any) => {

      result.forEach((email) => {
        const details = {
          ed: email._id,
          from: email.from_name,
          subject: email.original_subject,
          text: email.text.slice(0, 40).concat('...')
        };
        underReview.push(details);
      });

      const underReviewWithSkill = this.getBotSkillNames(underReview);

      if (underReviewWithSkill && underReviewWithSkill.length > 0) {
        const reviewType = this.customerReviewQueueToggle ? 'under "customer needs review"' : 'under "needs review"';
        this.modalService.show(ConfirmDialogComponent, {
          initialState: {
            message: `Please confirm that you would like to send ${underReviewWithSkill.length} replies that are ${reviewType} to ${accountName}.`,
            confirm: () => {
              this.userService.botReviewEmail(accountId, accountName, underReviewWithSkill, approveStatus).subscribe(() => {
                this.globalMessageService.message('Bot review email was sent');
              },
                (error) => {
                  this.globalMessageService.error();
                  throw error;
                }
              );
            }
          }
        });
      } else {
        this.modalService.show(AlertDialogComponent, {
          initialState: {
            header: 'No Replies to Send',
            message: `${accountName} has 0 bot skill emails "under review".`,
            confirmBtn: 'Ok'
          }
        });
      }
    },
      (error) => {
        this.globalMessageService.error();
        throw error;
      }
    );
  }

  getBotSkillNames(underReview: any) {

    underReview.forEach((email) => {
      const ed = email.ed;
      this.approveQService.getByEmailDetail(ed).subscribe(
        (result: any) => {
          this.automateJobService.adminGetJobById(result[0].automate_job_id).subscribe(
            (job: any) => {
              const name = job.name;
              email.skillName = name;
            });
        });
    });

    return underReview;
  }

  export() {
    this.globalMessageService.message('Your export should download in the next few seconds');
    const payload = {
      startDate: this.dateRangeOptions.startDate,
      endDate: this.dateRangeOptions.endDate,
      recipient: this.session.inbox_filters.recipient
    };

    if (this.session.inbox_filters.types.length > 0 && this.session.inbox_filters.types.length != this.types.length) {
      payload['type'] = this.session.inbox_filters.types;
    }

    if (this.session.inbox_filters.sources.length > 0 && this.session.inbox_filters.sources.length != this.sources.length) {
      payload['source'] = this.session.inbox_filters.sources;
    }

    this.emailDetailService.getExport(payload).subscribe(
      (result: any) => {
        this.exportData = result;
        this.driftService.track('generated-export', { type: 'inbox' });
        this.driftService.track('generated-export', { type: 'inbox' });
      },
      (error) => {
        this.globalMessageService.error();
        this.errorService.log(error, 'inbox.component', 'export');
      }
    );
  }

  botStatusChange(status: string) {
    const ed = this.emails.find((email) => email._id == this.selectedEmailId);
    ed.approve_status = status;
    this.cdRef.detectChanges();
  }

  onDeleteEmail() {
    this.resetData(false);
  }

  private async initView() {
    if (!this.session) {
      this.globalMessageService.error();
      this.errorService.log(new Error('session not initialized'), 'inbox.component', 'initView');
    }

    if (this.session.f) {
      this.customerReviewQueueToggle = this.session.f.customerReviewQueue || false;
    }

    const isSAdmin = await this.authService.hasPermission('sadmin')

    if (this.session.account_id && isSAdmin) {
      const accountId = this.session.account_id;
      this.userService.getUsersWithBotReviewQueue(accountId).subscribe(
        (users: any) => {
          this.usersWithReviewNotifications = users;
        }
      );
    }

    // set up valid types for filter
    this.types = _.map(this.constants.emailTypes, (t: EmailType) => {
      return { id: t.typeName, itemName: t.display };
    });
    this.types.splice(this.types.findIndex((t) => t.id == 'all'), 1);
    this.types.splice(this.types.findIndex((t) => t.id == 'notification'), 1);

    // hide direct types if the feauture is not turned on
    if (!this.session.f.directmail) {
      this.types.splice(this.types.findIndex((t) => t.id == 'humandirect'), 1);
      this.types.splice(this.types.findIndex((t) => t.id == 'spam'), 1);
    }

    this.types.sort((a, b) => {
      if (a.itemName > b.itemName) {
        return 1;
      }
      else {
        return -1;
      }
    });

    let now = new Date();
    if (!this.session.inbox_filters || !this.session.inbox_filters.last_changed) {
      // make sure inbox filters exist for this user
      this.resetFilters();
    }
    else if (now.getTime() - new Date(this.session.inbox_filters.last_changed).getTime() > 900000) {
      // 900000ms = 15 minutes. Let's reset filters if it's been more than 15 minutes since they were last last changed
      this.resetFilters();
    }
    else if (this.session.inbox_filters && this.session.inbox_filters.type) {
      // old filter value, reset if this exists
      this.resetFilters();
    }

    if (this.session.inbox_filters.range) {
      // custom range is currently selected
      this.dateRangeOptions.startDate = new Date(this.session.inbox_filters.range.start);
      this.dateRangeOptions.endDate = new Date(this.session.inbox_filters.range.end);
    }
    else {
      // standard "time ago" is currently selected
      this.dateRangeOptions.endDate = new Date();
      this.dateRangeOptions.startDate = new Date();
      if (this.session.inbox_filters.days > 0) {
        this.dateRangeOptions.startDate.setDate(this.dateRangeOptions.endDate.getDate() - this.session.inbox_filters.days + 1);
      }
      else {
        // special case for "yesterday"
        this.dateRangeOptions.startDate.setDate(this.dateRangeOptions.endDate.getDate() - 1);
        this.dateRangeOptions.endDate.setDate(this.dateRangeOptions.endDate.getDate() - 1);
      }
    }

    // set up selected types
    this.session.inbox_filters.types.forEach((type) => {
      let et: EmailType = this.constants.emailTypes.find((t) => t.typeName == type);
      this.selectedTypes.push({
        id: et.typeName,
        itemName: et.display
      });
    });

    // make sure inbox_filters.sources exist
    if (!this.session.inbox_filters.sources) {
      this.session.inbox_filters.sources = [];
    }

    // make sure inbox_filters.approve_status exist
    if (!this.session.inbox_filters.approve_status) {
      this.session.inbox_filters.approve_status = [];
    }

    if (!this.session.inbox_filters.bot_classification) {
      this.session.inbox_filters.bot_classification = [];
    }

    if (this.sAdmin === null) {
      this.sAdmin = await this.authService.hasPermission('sadmin');
    }

    // set up bot status
    this.session.inbox_filters.approve_status.forEach((bs) => {
      const botst: any = !this.customerReviewQueueToggle ?
        this.approveStatuses.find((b) => b.id == bs) : this.sAdmin ? this.adminApproveStatuses.find((b) => b.id == bs) : this.customerApproveStatuses.find((b) => b.id == bs);
      this.selectedApproveStatuses.push(botst);

    });

    // pre-load sources in case they are needed
    this.sourceService.getSources().subscribe(
      (result: any) => {
        this.sources = _.map(result, (s: any) => {
          return { id: s._id, itemName: (s.email_address.length > 26 ? (s.email_address.substring(0, 23) + '...') : s.email_address) };
        });

        // mark any sources selected that are in the session
        this.session.inbox_filters.sources.forEach((s) => {
          const foundSource = _.find(this.sources, (source: any) => {
            return source.id == s;
          });
          if (foundSource) {
            this.selectedSources.push(foundSource);
          }
        });

        this.resetData(true);
      },
      () => {}
    );

    if (this.session.f.bot) {
      this.classifierService.getBotClassifiers('all+campaigns').subscribe((results) => {
        this.botClassifications = _.flatten(results.map(({ job, classifier }) => {
          return classifier.training.nb.category.map((category) => ({
            id: `${job._id}:${category.id}`,
            itemName: `${job.name} - ${category.name}`,
          }));
        }));
        this.selectedBotClassifications = this.session.inbox_filters.bot_classification
          .map((classificationId) => this.botClassifications.find((classification) => classification.id === classificationId));
      });
    }
  }

  private resetData(fresh: boolean) {
    if (fresh) {
      this.changePageInternal(0, this.session.inbox_filters.new_page);
    }
    else {
      this.qsEmailId = null;
      this.changePageInternal(this.session.inbox_filters.current_page, this.session.inbox_filters.new_page);
    }

    this.loadingCount = true;

    const countPayload: any = {
      startDate: this.dateRangeOptions.startDate,
      endDate: this.dateRangeOptions.endDate,
      recipient: this.session.inbox_filters.recipient,
    };

    if (this.session.inbox_filters.types.length > 0 && this.session.inbox_filters.types.length != this.types.length) {
      countPayload.type = this.session.inbox_filters.types;
    }

    if (this.session.inbox_filters.sources.length > 0 && this.session.inbox_filters.sources.length != this.sources.length) {
      countPayload.source = this.session.inbox_filters.sources;
    }

    if (this.session.inbox_filters.approve_status.length > 0) {
      countPayload.approve_status = this.session.inbox_filters.approve_status;
    }

    if (this.session.inbox_filters.bot_classification.length > 0) {
      countPayload.bot_classification = this.session.inbox_filters.bot_classification;
    }

    if (this.sAdmin !== null) {
      countPayload.sAdmin = this.sAdmin;
    }

    if (this.customerReviewQueueToggle !== null) {
      countPayload.customerReviewQueueToggle = this.customerReviewQueueToggle;
    }

    this.emailDetailService.getCount(countPayload).subscribe(
      (result: any) => {
        this.totalEmails = result.count;
        if (this.totalEmails == 0) {
          this.emails = [];
          this.loadingPage = false;
        }
        else {
          this.numPages = Math.floor(this.totalEmails / this.perPage);
          if (this.totalEmails % this.perPage > 0) {
            this.numPages++;
          }
        }
        this.loadingCount = false;
      },
      (error) => {
        this.globalMessageService.error();
        this.errorService.log(error, 'inbox.component', 'resetData');
      }
    );
  }

  private changePageInternal(currentPage: number, newPage: number) {
    this.loadingPage = true;
    let startDT = new Date();
    startDT.setTime(startDT.getTime() - (this.session.inbox_filters.days * 24 * 60 * 60 * 1000));
    const query: IQuery = {
      startDate: this.dateRangeOptions.startDate,
      endDate: this.dateRangeOptions.endDate,
    };

    if (this.session.inbox_filters.types.length > 0 && this.session.inbox_filters.types.length != this.types.length) {
      query.type = this.session.inbox_filters.types;
    }

    if (this.session.inbox_filters.sources.length > 0 && this.session.inbox_filters.sources.length != this.sources.length) {
      query.source = this.session.inbox_filters.sources;
    }

    if (this.session.inbox_filters.recipient.length > 0) {
      query.recipient = this.session.inbox_filters.recipient;
    }

    if (this.session.inbox_filters.approve_status.length > 0) {
      query.approve_status = this.session.inbox_filters.approve_status;
    }

    if (this.session.inbox_filters.bot_classification.length > 0) {
      query.bot_classification = this.session.inbox_filters.bot_classification;
    }

    if (this.sAdmin !== null) {
      query.sAdmin = this.sAdmin;
    }

    if (this.customerReviewQueueToggle !== null) {
      query.customerReviewQueueToggle = this.customerReviewQueueToggle;
    }

    const options = {
      current_page: currentPage,
      new_page: newPage,
      firstId: this.session.inbox_filters.firstId,
      lastId: this.session.inbox_filters.lastId,
      query: query,
      count: this.perPage
    };

    this.emailDetailService.getPaginated(options).subscribe(
      (result: any) => {
        this.emails = result;
        if (this.qsEmailId) {
          // deep linked to a specific email, load it in the detail pane no matter what
          this.selectedEmailId = this.qsEmailId;
        }

        if (this.emails.length > 0) {
          if (!this.qsEmailId) {
            // only set this if not deep linked
            this.selectedEmailId = this.emails[0]._id;
          }

          this.emails.forEach((e) => {
            e.domain = e.from_address.split('@')[1];
            e.typeDisplay = this.constants.emailTypes.find((ct) => {
              return ct.typeName == e.type;
            }).display;

            if (e.typeData.origin_type == 101) {
              e.origin = 'Reply';
            }
            else {
              e.origin = 'Direct';
            }
          });

          this.session.inbox_filters.current_page = currentPage; // $scope.userSession.inbox_filters.new_page;
          this.session.inbox_filters.new_page = newPage; // page;
          this.session.inbox_filters.firstId = this.emails[0].date;
          this.session.inbox_filters.lastId = this.emails[this.emails.length - 1].date;
          this.saveSession();
        }
        else {
          this.selectedEmailId = null;
        }
        this.loadingPage = false;
      },
      (error) => {
        this.globalMessageService.error();
        this.errorService.log(error, 'inbox.component', 'changePageInternal');
      }
    );
  }

  private saveSession() {
    this.session.inbox_filters.last_changed = new Date();
    this.sessionService.saveSession(this.session).subscribe(
      () => {
        // Nothing
      },
      (err) => {
        this.errorService.log(err, 'inbox.component', 'saveSession');
      }
    );
  }

  private resetFilters() {
    this.session.inbox_filters = {
      range: null,
      days: 30,
      types: [],
      sources: [],
      recipient: '',
      approve_status: [],
      bot_classification: [],
      current_page: 0,
      new_page: 1,
      firstId: null,
      lastId: null
    };
    this.selectedSources = [];
    this.saveSession();
  }

  updateBotStatus(emailId: string, status: string) {
    let ed = this.emails.find((email) => email._id == emailId );
    if (ed) {
      // Changed leaves a bad status on the ed.approve_status making the "needs review" tag disappear
      if (status != 'changed') {
        ed.approve_status = status;
      }

      this.loadingDetail = true;
      this.cdRef.detectChanges();
    }
  }

  refreshInbox() {
    this.resetData(true);
  }

}



// WEBPACK FOOTER //
// ./client/app/inbox/inbox.component.ts